// ── PLOW "My month": which weeks a month covers ─────────────────────────────
//
// The month view is the board's week grid cut to one person's row, a line per
// week. A week belongs to the month when any day the board shows (Mon to Fri,
// or Mon to Sun with weekends on) falls inside it, so a weekday board never
// opens on a week that is all last month's. UTC string arithmetic, like the
// rest of the PLOW.

const addDays = (iso, n) => {
  const d = new Date(`${iso}T00:00:00Z`);
  d.setUTCDate(d.getUTCDate() + n);
  return d.toISOString().slice(0, 10);
};

/** 'YYYY-MM' moved by n months. */
export function shiftMonth(month, n) {
  const d = new Date(`${month}-01T00:00:00Z`);
  d.setUTCMonth(d.getUTCMonth() + n);
  return d.toISOString().slice(0, 7);
}

/** The Mondays of the weeks whose shown days touch 'YYYY-MM'. */
export function monthWeekStarts(month, includeWeekends) {
  const first = new Date(`${month}-01T00:00:00Z`);
  let monday = addDays(`${month}-01`, -((first.getUTCDay() + 6) % 7));
  const span = includeWeekends ? 6 : 4;
  const out = [];
  for (; monday.slice(0, 7) <= month; monday = addDays(monday, 7)) {
    if (addDays(monday, span).slice(0, 7) >= month) out.push(monday);
  }
  return out;
}

/**
 * Is My month offered on this board? Not to members and viewers of a
 * current-week-only board: past this week it would be refused weeks.
 */
export function myMonthAvailable(plow) {
  return !plow?.current_week_only || plow.my_level === 'editor';
}
